import { useQuery } from "@apollo/react-hooks";
import React, { useCallback, useMemo, useRef } from "react";
import { GET_AMAZON_IDEA_TEMPLATES } from "../../graphql/queries/amazon-idea";
import { reducerFn } from "../../helper";
import AutocompleteV2 from "../shared/AutocompleteV2";
import { get } from "lodash";
import { Link, Stack } from "@shopify/polaris";
import { calcuKpi } from "../amazon-idea/amazon-idea-field";

function AmazonIdeaTemplateAutocomplete({ setState, param }) {
    const [filter, setFilter] = React.useReducer(reducerFn, {
        limit: 20,
        offset: 0,
        search: "",
    });

    const { data, loading, error } = useQuery(GET_AMAZON_IDEA_TEMPLATES, {
        variables: {
            filter,
        },
        fetchPolicy: "no-cache",
    });

    const handleChange = useCallback((_, obj) => {
        if (!obj || !obj.data || !obj.data.fields) return;

        const kpi = calcuKpi((obj.data.fields?.length || 0) - 1);
        setState((p) => ({
            ...p,
            fields: obj.data.fields,
            kpi: String(Number(1) + kpi),
        }));
    }, []);

    const acRef = useRef(null);
    const options = useMemo(() => {
        const options = getOptions(data);
        if (options.length > 0) {
            acRef.current?.handleFocus && acRef.current.handleFocus();
        }

        return options;
    }, [JSON.stringify(data)]);

    return (
        <div
            style={{
                maxWidth: "30rem",
                marginBottom: "1rem",
                marginLeft: "1rem",
            }}
        >
            <Stack vertical spacing="extraTight">
                <AutocompleteV2
                    label="Apply a template"
                    options={options}
                    value={[]}
                    loading={loading}
                    error={error}
                    onChange={handleChange}
                    setFilter={setFilter}
                    getValueImmediate
                    ref={acRef}
                    placeholder="Choose template"
                />
                <Link url={`/${param}/amazon-idea-templates`}>
                    Manager template
                </Link>
            </Stack>
        </div>
    );
}

function getOptions(res) {
    const nodes = get(res, "getAmazonIdeaTemplates.nodes") || [];
    const arr = [];
    for (let item of nodes) {
        if (!item || !item.id) continue;

        const { id, title, fields } = item;
        arr.push({
            value: id,
            label: title || "",
            data: { id, title, fields },
        });
    }

    return arr;
}

export default AmazonIdeaTemplateAutocomplete;
